import { render, staticRenderFns } from "./CustomerRequest.vue?vue&type=template&id=8b3c0b3e&scoped=true&"
import script from "./CustomerRequest.vue?vue&type=script&lang=js&"
export * from "./CustomerRequest.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/page/customerRequest.css?vue&type=style&index=0&id=8b3c0b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3c0b3e",
  null
  
)

export default component.exports